import styled from 'styled-components';

export const StyledExpandableSubRow = styled.div`
  .table {
    col {
      &:nth-of-type(1) {
        width: 10% !important;
      }
      &:nth-of-type(2) {
        width: 50% !important;
      }
      &:nth-of-type(3) {
        width: 35% !important;
      }
      &:nth-of-type(4) {
        width: 5% !important;
      }
    }

    tbody {
      tr {
        td {
          background-image: none !important;
          background-color: white !important;
        }
      }
    }
  }
`;
